import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TechnicalDeviceFormComponent} from './technical-device-form/technical-device-form.component';
import {TechnicalDeviceObjectForCreateResolverService} from './services/technical-device-object-for-create.resolver.service';
import {TechnicalDeviceViewComponent} from './technical-device-view/technical-device-view.component';
import {DocumentsComponent} from './subpages/documents/documents.component';
import {TechnicalDeviceResolver} from './services/technical-device.resolver';
import {TechnicalDevicesObjectsResolver} from './services/technical-devices-objects.resolver';
import {CheckPermissionsGuardService} from '@services/guards/check-permissions.guard.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {ElementsGroupsComponent} from './subpages/elements-groups/elements-groups.component';
import {ConclusionsComponent} from './subpages/conclusions/conclusions.component';
import {TechnicalDevicesSummaryInfoResolver} from './services/technical-devices-summary-info.resolver';
import {DeviceDocumentFormModalComponent} from './components/device-document-form-modal/device-document-form-modal.component';
import {
    ElementsGroupTechCardModalFormComponent
} from './components/elements-group-tech-card-modal-form/elements-group-tech-card-modal-form.component';
import {TechnicalDeviceElementGroupsResolver} from './services/element-groups/technical-device-element-groups.resolver';
import {TechnicalDeviceElementsResolver} from './services/elements/technical-device-elements.resolver';
import {TechnicalDeviceDocumentsResolver} from './services/documents/technical-device-documents.resolver';
import {RoutesStorage} from '@helpers/routes.helper';

/**
 * Роутинг ТУ, используемый как вложенный в модуле объектов, чтобы запускать компоненты из под роута объектов
 * вида /working-objects/view/:id/technical-device/new
 */
export const technicalDeviceRouterForWorkingObject: Routes = [
    {
        path: '',
        children: [
            {
                path: ':objectId/new',
                component: TechnicalDeviceFormComponent,
                canActivate: [CheckPermissionsGuardService],
                resolve: {
                    object: TechnicalDeviceObjectForCreateResolverService,
                    objects: TechnicalDevicesObjectsResolver,
                },
                data: {
                    title: 'Новое техническое устройство',
                    permissions: [
                        UserNamespace.Permission.technicalDeviceCreate,
                    ],
                    fallbackUrl: RoutesStorage.WorkingObject.list
                },
            },
            {
                path: ':id/edit',
                component: TechnicalDeviceFormComponent,
                canActivate: [CheckPermissionsGuardService],
                resolve: {
                    device: TechnicalDeviceResolver,
                    objects: TechnicalDevicesObjectsResolver,
                },
                data: {
                    title: 'Редактирование технического устройства',
                    permissions: [
                        UserNamespace.Permission.technicalDeviceUpdate,
                    ],
                    fallbackUrl: RoutesStorage.WorkingObject.list
                },
            },
            {
                path: ':id/view',
                component: TechnicalDeviceViewComponent,
                canActivate: [CheckPermissionsGuardService],
                resolve: {
                    device: TechnicalDeviceResolver,
                    summaryInfo: TechnicalDevicesSummaryInfoResolver,
                },
                data: {
                    title: 'Техническое устройство',
                    permissions: [
                        UserNamespace.Permission.technicalDeviceView,
                    ],
                    fallbackUrl: RoutesStorage.WorkingObject.list
                },
                children: [
                    {
                        path: '',
                        redirectTo: 'conclusion',
                        pathMatch: 'full'
                    },
                    {
                        path: 'elements-groups',
                        component: ElementsGroupsComponent,
                        canActivate: [
                            CheckPermissionsGuardService
                        ],
                        data: {
                            permissions: [
                                UserNamespace.Permission.technicalDeviceElementGroupView,
                                UserNamespace.Permission.technicalDeviceElementGroupList,
                            ],
                            fallbackUrl: '../documents',
                            fallbackByRelative: true,
                        },
                        resolve: {
                            data: TechnicalDeviceElementGroupsResolver,
                        },
                        children: [
                            {
                                path: '',
                                outlet: 'modal',
                                data: {
                                    scrollTop: false,
                                },
                                children: [
                                    {
                                        path: 'technical-card-document',
                                        children: [
                                            {
                                                path: ':technicalCardId/edit',
                                                component: ElementsGroupTechCardModalFormComponent,
                                                canActivate: [
                                                    CheckPermissionsGuardService
                                                ],
                                                data: {
                                                    title: 'Редактирование техкарты',
                                                    permissions: [
                                                        UserNamespace.Permission.technicalCardCreate,
                                                    ],
                                                    scrollTop: false,
                                                },
                                            },
                                        ]
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        path: 'documents',
                        component: DocumentsComponent,
                        resolve: {
                            data: TechnicalDeviceDocumentsResolver,
                        },
                        data: {

                        },
                        children: [
                            {
                                path: '',
                                outlet: 'modal',
                                data: {
                                    scrollTop: false,
                                },
                                children: [
                                    {
                                        path: 'new',
                                        component: DeviceDocumentFormModalComponent,
                                        canActivate: [
                                            CheckPermissionsGuardService
                                        ],
                                        data: {
                                            title: 'Добавление документации',
                                            permissions: [
                                                UserNamespace.Permission.technicalDeviceDocumentationCreate,
                                            ],
                                            scrollTop: false,
                                        },
                                    },
                                    {
                                        path: 'edit/:documentationId',
                                        component: DeviceDocumentFormModalComponent,
                                        canActivate: [
                                            CheckPermissionsGuardService
                                        ],
                                        data: {
                                            title: 'Редактирование документации',
                                            permissions: [
                                                UserNamespace.Permission.technicalDeviceDocumentationUpdate,
                                            ],
                                            scrollTop: false,
                                        },
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'conclusion',
                        component: ConclusionsComponent,
                        data: {
                            permissions: [
                                UserNamespace.Permission.technicalDeviceElementView,
                                UserNamespace.Permission.technicalDeviceElementList,
                            ],
                            fallbackUrl: '../documents',
                            fallbackByRelative: true,
                        },
                        resolve: {
                            data: TechnicalDeviceElementsResolver,
                        },
                        canActivate: [
                            CheckPermissionsGuardService
                        ],
                    },
                ]
            },
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(technicalDeviceRouterForWorkingObject),
    ],
    exports: [
        RouterModule
    ]
})
export class TechnicalDeviceRoutingModule {}
